import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';

export default function SubmitRequest({ onCancel, setOptionNumber, open }) {
  const header = "We're on it";

  const content = `Hang tight while a member of our team reviews your request. You should receive a response within 72 hours.`;

  const action = (
    <div>
      <Button variant="contained" color="primary" onClick={() => onCancel()}>
        Thanks!
      </Button>
    </div>
  );

  return (
    <Dialog
      open={open}
      header={header}
      description={content}
      actions={action}
      onClose={onCancel}
      maxWidth={500}
    />
  );
}
